import { styled } from '@mui/material'

interface BoundsProps {
  x: number
  y: number
  width: number | string
  height: number | string
  zIndex: number
}

const shouldForwardProp = (propName: PropertyKey) =>
  propName !== 'x' &&
  propName !== 'y' &&
  propName !== 'width' &&
  propName !== 'height' &&
  propName !== 'zIndex'

export const HoverArea = styled('div', { shouldForwardProp })<BoundsProps>(
  ({ x, y, width, height, zIndex }) => ({
    height,
    left: x,
    position: 'absolute',
    top: y,
    width,
    zIndex,
  }),
)

// The anchor is the same absolutely-positioned bounds box, handed a different
// rect (a 1x1 point at the top centre) so the tooltip hangs off it. Give it its
// own rules only if it should stop matching.
export const TooltipAnchor = HoverArea
